export function loadImage(url){
    return new Promise(resolve =>{
        const image = new Image();
        image.addEventListener('load', () =>{
            resolve(image);
        });
        image.src = "images/" + url;
    })
}